export function createNavigation(options) {
    if (!options.containerSelector || !options.elementsSelector) {
        return;
    }
    var container = document.querySelector(options.containerSelector);
    if (!container) {
        return;
    }
    container.addEventListener('keydown', function (event) {
        var key = event.key;
        var selectedClassSelector = '.' + options.selectedClass;
        var currentSelected = container.querySelector(selectedClassSelector);
        var elements = Array.from(container.querySelectorAll(options.elementsSelector));
        if (elements.length === 0) {
            return;
        }
        var buttonSearch = container.querySelector(options.buttonSearchSelector);
        if (['ArrowUp', 'ArrowDown'].includes(key)) {
            event.preventDefault();
            event.stopPropagation();
            if (!currentSelected) {
                currentSelected = elements[0];
                currentSelected.classList.add(options.selectedClass);
                currentSelected.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "nearest"
                });
                return;
            }
            var newSelected = null;
            switch (key) {
                case 'ArrowUp':
                    newSelected = getPreviousSiblingBySelector(currentSelected, options.elementsSelector);
                    break;
                case 'ArrowDown':
                    newSelected = getNextSiblingBySelector(currentSelected, options.elementsSelector);
                    break;
            }
            if (!newSelected) {
                currentSelected.classList.remove(options.selectedClass);
                return;
            }
            currentSelected.classList.remove(options.selectedClass);
            newSelected.classList.add(options.selectedClass);
            newSelected.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest'
            });
        }
        if (key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            if (currentSelected) {
                currentSelected.click();
            }
            else if (buttonSearch) {
                buttonSearch.click();
            }
        }
    });
}
function getNextSiblingBySelector(element, selector) {
    var sibling = element.nextElementSibling;
    while (sibling) {
        if (sibling.matches(selector)) {
            return sibling;
        }
        sibling = sibling.nextElementSibling;
    }
    return null;
}
function getPreviousSiblingBySelector(element, selector) {
    var sibling = element.previousElementSibling;
    while (sibling) {
        if (sibling.matches(selector)) {
            return sibling;
        }
        sibling = sibling.previousElementSibling;
    }
    return null;
}
